module.exports = __webpack_public_path__ + "img/28_41.4459e199.png";